import React, { useEffect, useState } from 'react';

import ic_search from "assets/images/ic_search.svg";

import 'assets/scss/components/filters/searchBox.scss';
import { getObjectPropertyValue, getStringUniqueId, isArrayNotEmpty, isFunction, isNotNullUndefined, isStringEqual_caseInsensitive, isStringEqual_caseSensitive, isStringTrimEmpty, isStringTrimNotEmpty } from 'functions';
import { Toaster } from 'components/notification/Toaster';


export function SearchBox(props) {
    const { 
        className,
        sideIconClassName, inputWrapperClassName, 
        optionItemClassName,
        inputClassName, optionClassName,

        label: label_props,

        isIconOnLeftSide, isSideIconHidden,
        isSuggestionListRequired, 
        isResetRequired, isInputDigitOnly,

        placeholder, isPlaceholderHidden,

        suggestionList,

        onBlurInput, isDisabled,

        // Functions
        onEnterPressed = () => {}
    } = props;

    const [suggestionEleId] = useState(getStringUniqueId("component-search-box-suggestionList"));
    const [componentUniqueId] = useState(getStringUniqueId("component-search-box"));
    const [inputWrapperUniqueId] = useState(getStringUniqueId("component-search-box__input-wrapper"));
    const [searchIconUniqueId] = useState(getStringUniqueId("component-search-box__search-icon"));
    const [searchInputUniqueId] = useState(getStringUniqueId("component-search-box__search-input"));
    const [isSubmissionAttempted, setIsSubmissionAttempted] = useState();

    // Props validations
    let placeholder_formatted = isStringTrimNotEmpty(placeholder)? placeholder: "Search...";

    const [label, setLabel] = useState(label_props? label_props:"");
    const [isSuggestionListHidden, setIsSuggestionListHidden] = useState();

    function getValueFromList() {
        let matchedValue = undefined;
        if (isArrayNotEmpty(suggestionList)) {
            for (let i = 0; i < suggestionList.length; i++) {
                let suggestionLabel = getObjectPropertyValue(suggestionList[i], "label","") + "";
                let suggestionValue = getObjectPropertyValue(suggestionList[i], "value","");

                if (isStringEqual_caseInsensitive(suggestionLabel, label)) {
                    matchedValue = suggestionValue;
                    break;
                }
                else if (suggestionList[i]?.subItems) {
                    let subItems = suggestionList[i].subItems;

                    if (isArrayNotEmpty(subItems)) {
                        for (let j = 0; j < subItems.length; j++) {
                            let suggestionLabel = getObjectPropertyValue(subItems[j], "label","") + "";
                            let suggestionValue = getObjectPropertyValue(subItems[j], "value","");

                            if (isStringEqual_caseInsensitive(suggestionLabel, label)) {
                                matchedValue = suggestionValue;
                                break;
                            }
                        }
                    }
                }
            }
        }

        return matchedValue;
    }

    function handleSearchTerm_OnChange(label) {
        setLabel(label);

        if (isNotNullUndefined(label) &&
            props.handleOnChange) 
            props.handleOnChange(label);
    }

    function handleSearchTermOn_KeyUp(e) {
        let keyCode = e.keyCode;
        let value = (isArrayNotEmpty(suggestionList))? getValueFromList(): e.target.value;
        value = isNotNullUndefined(value)? value + "": e.target.value;

        // on Enter
        if ((keyCode == 13) &&
            isStringTrimNotEmpty(value)) {

            setIsSubmissionAttempted(true);
            onEnterPressed(value);
        }

        // on Empty Input
        if (isStringTrimEmpty(label) &&
            props.handleOnEmptyInput) 
            props.handleOnEmptyInput();
    }

    function handleOnSubmit() {
        // Get value
        let value = (isArrayNotEmpty(suggestionList))? getValueFromList(): label;
        let details = findMatchedItem();
        let isDisabled = details?.isDisabled;
        let disabledMsg = details?.disabledMsg;

        if (isDisabled &&
            isStringTrimNotEmpty(disabledMsg)) {
            
            Toaster({
                type: "error",
                msg: disabledMsg
            })
        }
        else if (isNotNullUndefined(value) &&
            isFunction(props.onSubmit)) {

            props.onSubmit(value);
        }

        setIsSubmissionAttempted(false);
    }
    function findMatchedItem() {
        let matchedDetails = {};
        if (isArrayNotEmpty(suggestionList)) {
            suggestionList.map((details, idx) => {
                let itemLabel = getObjectPropertyValue(details, "label","") + "";
                let subItems = getObjectPropertyValue(details, "subItems", []);

                if (isStringEqual_caseInsensitive(itemLabel, label)) {
                    matchedDetails = details;
                }
                else if (isArrayNotEmpty(subItems)) {
                    subItems.map((subDetails, idx) => {
                        let itemLabel = getObjectPropertyValue(subDetails, "label","") + "";

                        if (isStringEqual_caseInsensitive(itemLabel, label)) {
                            matchedDetails = subDetails;
                        }
                    })
                }
            })
        }
        return matchedDetails;
    }
    useEffect(() => {
        if (isSubmissionAttempted)
            handleOnSubmit();
    }, [isSubmissionAttempted])

    let suggestionArray = [];
    if (isArrayNotEmpty(suggestionList)) {
        for (let i = 0; i < suggestionList.length; i++) {
            let details = suggestionList[i];
            let itemLabel = getObjectPropertyValue(details, "label","") + "";
            let className = getObjectPropertyValue(details, "className","");
            let isGrouped = getObjectPropertyValue(details, "isGrouped", false);
            let subItems = getObjectPropertyValue(details, "subItems", []);

            if (isGrouped &&
                isArrayNotEmpty(subItems)) {
                let groupHeader = itemLabel;

                let isHeaderVisible = (isStringTrimNotEmpty(groupHeader) &&
                    isStringTrimNotEmpty(label) &&
                    groupHeader.toLowerCase().includes(label));

                let isSubMenuMatched = false;
                for (let j = 0; j < subItems.length; j++) {
                    let suggestionLabel = getObjectPropertyValue(subItems[j], "label","") + "";
                    isSubMenuMatched = (isStringTrimNotEmpty(suggestionLabel) &&
                        isStringTrimNotEmpty(label) &&
                        suggestionLabel.toLowerCase().includes(label));

                    if (isSubMenuMatched) break;
                }

                if (isSubMenuMatched || isHeaderVisible) {
                    suggestionArray.push(
                        <div key={i}
                            className={"suggestion-list__group-option "}>
                            {/* Item */}
                            {isHeaderVisible || isSubMenuMatched? (
                                <div className={"group-option__item " +
                                    (className? className + " ":"")}
                                    onClick={() => {
                                        handleSearchTerm_OnChange(groupHeader);
                                        setIsSubmissionAttempted(true);
                                    }}
                                >
                                    {groupHeader}
                                </div>
                            ):""}
    
                            {/* Sub items */}
                            {subItems.map((itemObj, idx) => {
                                let subItemLabel = getObjectPropertyValue(itemObj, "label","") + "";
                                let className = getObjectPropertyValue(itemObj, "className","");
                
                                let isSubItemVisible = (isStringTrimNotEmpty(subItemLabel) &&
                                    isStringTrimNotEmpty(label) &&
                                    subItemLabel.toLowerCase().includes(label));
                                    
                                return isSubItemVisible? (
                                    <div key={idx} 
                                        className={"group-option__sub-item " +
                                            (className? className + " ":"")}
                                        onClick={() => {
                                            handleSearchTerm_OnChange(subItemLabel);
                                            setIsSubmissionAttempted(true);
                                        }}
                                    >
                                        {subItemLabel}
                                    </div>
                                ):"";
                            })}
                        </div>
                    );
                }
            }
            else if (isStringTrimNotEmpty(itemLabel) &&
                isStringTrimNotEmpty(label) &&
                itemLabel.toLowerCase().includes(label)) {
                suggestionArray.push(
                    <div key={i}
                        className={"suggestion-list__option " +
                            (className? className + " ":"") +
                            (optionItemClassName? optionItemClassName + " ":"")}
                        onClick={() => {
                            handleSearchTerm_OnChange(itemLabel);
                            setIsSubmissionAttempted(true);
                        }}
                    >
                        {itemLabel}
                    </div>
                );
            }
        }
        suggestionArray.sort();
    }

    useEffect(() => {
        if (isResetRequired) setLabel("");
    },[isResetRequired]);


    function handleComponentOnBlur(e) {
        // Entire Component on blur
        if (!(isStringEqual_caseSensitive(e.target.id, inputWrapperUniqueId) ||
            isStringEqual_caseSensitive(e.target.id, searchIconUniqueId) ||
            isStringEqual_caseSensitive(e.target.id, searchInputUniqueId))) {

            setIsSuggestionListHidden(true);

            if (isFunction(props?.onComponentBlur))
                props.onComponentBlur();
        }
    }
    useEffect(() => {
        window.addEventListener("click", handleComponentOnBlur);
        return () => {
            window.removeEventListener("click", handleComponentOnBlur);
        }
    });

    let isOptionListVisible = ((isStringTrimNotEmpty(label)) && 
        isSuggestionListRequired && 
        !isSuggestionListHidden &&
        isArrayNotEmpty(suggestionArray));

    useEffect(() => {
        if (isFunction(props.onOptionVisibilityChange))
            props.onOptionVisibilityChange(isOptionListVisible);
    }, [isOptionListVisible]);

    return (
        <div id={componentUniqueId} className={"component-search-box " + 
                (className? className + " ":"")}
        >
            <div id={inputWrapperUniqueId} className={"component-search-box__input-wrapper h-100 d-flex align-items-center " +
                    (inputWrapperClassName? inputWrapperClassName + " ":"") +
                    (isDisabled? "component-search-box__input-wrapper_disabled ":"")}
            >
                {/* Side Icon */}
                {isSideIconHidden? "":(
                    <img 
                        id={searchIconUniqueId}
                        className={"input-wrapper__side-icon " +
                            (sideIconClassName? sideIconClassName + " ":"") +
                            (isIconOnLeftSide? "input-wrapper__side-icon_left ":"")} 
                        src={ic_search}
                        alt={"Input side icon"}

                        onClick={() => setIsSubmissionAttempted(true)}
                    />
                )}

                {/* Input */}
                <input type={"text"} id={searchInputUniqueId}
                    className={"input-wrapper__search-input " +
                        (inputClassName? inputClassName + " ":"") +
                        (isIconOnLeftSide? "input-wrapper__search-input_left ":"")}
                    value={label}
                    placeholder={isPlaceholderHidden? "":placeholder_formatted}
                    disabled={isDisabled}
                    onChange={(e) => {
                        const { value } = e.target;

                        // Digit only
                        let value_formatted = value;
                        if (isInputDigitOnly) {
                            value_formatted = value_formatted.replace(/[^0-9]/g, "");
                        }
                        handleSearchTerm_OnChange(value_formatted);
                    }}
                    onFocus={() => setIsSuggestionListHidden(false)}
                    onKeyUp={handleSearchTermOn_KeyUp}
                    onBlur={onBlurInput}
                />
            </div>

            {/* Option List */}
            {isOptionListVisible? (
                
                <div id={suggestionEleId} 
                    className={"component-search-box__suggestion-list " +
                        (optionClassName? optionClassName + " ":"")}
                >
                    {suggestionArray}
                </div>
            ):""}
        </div>
    );
}